import React from 'react';
import { Link } from 'react-router-dom';
import { gettopBusinesses } from "../../api/ClientApi";


export default class VisitedOne extends React.Component {

    state = {
        topBusinesses: []
    };

    componentDidMount() {
        const secret_key = process.env.REACT_APP_SECRET_KEY;

        gettopBusinesses(secret_key)
            .then((data) => {
                this.setState({ topBusinesses: data });
            });
    }

    render() {
        const baseUrl = process.env.REACT_APP_API_URL;

        const businesses = this.props.isSearchActive
            ? this.props.businesses
            : this.state.topBusinesses;

        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                {/* Start Place One */}
                <section className="place-one">
                    <div className="container" >
                        <div className="sec-title text-center">
                            <h2 className="sec-title__title">Most Visited Business Locations</h2>
                            <p className="sec-title__text">Explore leading businesses that attract consistent customer engagement.</p>
                        </div>
						<div className="row">
						{Array.isArray(businesses) &&
							businesses.slice(0, 6).map((item, index) => (
								<div
									className="col-xl-4 col-lg-6 col-md-6"
									key={item.id || index}   
								>
									<div className="place-one__single">
										<div className="place-one__single-img">
											<div className="place-one__single-img-inner">
												<div className="icon-box">
													<Link to={process.env.PUBLIC_URL + `/`}>
														<span className="fa fa-heart"></span>
													</Link>
												</div>
												<img  style={{ width: 370, height: 265 }} src={`${baseUrl}bussinesslogo/logo/${item.logo || 'place-v1-img2.jpg'}`} alt="" />
											</div>

											<div className="text-box">
												<span>{item.name}</span>
											</div>
										</div>

										<div className="place-one__single-content">
											<div className="top-content">
												<h2>
													<Link to={process.env.PUBLIC_URL + `/`}>
														{item.category.title}
													</Link>
												</h2>

												<p>{item.description}</p>

												<div className="top-content-bottom">
													<div className="location-box">
														<div className="icon-box">
															<span className="fa fa-map-marker"></span>
														</div>
														<div className="text">
															<p>{item.statedetail.name}</p>
														</div>
													</div>

													<div className="number-box">
														<div className="icon">
															<span className="fa fa-map-marker"></span>
														</div>
														<div className="text">
															{item.countrydetail?.name || 'N/A'}
														</div>
													</div>
												</div>
											</div>
											
											<div className="bottom-content" style={{ display: "flex", justifyContent: "center" }}>
											  <Link
												to="/bussiness/detail"
												state={{ id: item.id }}
												className="thm-btn comment-form__btn"
												style={{ height: "50px", paddingTop: "10px", marginTop: "10px", marginBottom: "10px" }}
											  >
												
												Show More
											  </Link>
											</div>
											
											<div className="bottom-content">
												<ul className="review-box">
													<li><span className="fa fa-star"></span></li>
													<li><span className="fa fa-star"></span></li>
													<li><span className="fa fa-star"></span></li>
													<li><span className="icon-star-1"></span></li>
													<li><span className="icon-star-1"></span></li>
												</ul>
												<div className="count-box">
													<p>(03)</p> 
												</div>
											</div>
											
										</div>
									</div>
								</div>
							))
						}
					</div>

                       
                    </div>
                </section>
                {/* End Place One */}
            </>
        )
    }
}
